import { render, staticRenderFns } from "./FramenumberRecheck.vue?vue&type=template&id=2870bc39&scoped=true&"
import script from "./FramenumberRecheck.vue?vue&type=script&lang=js&"
export * from "./FramenumberRecheck.vue?vue&type=script&lang=js&"
import style0 from "./FramenumberRecheck.vue?vue&type=style&index=0&id=2870bc39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870bc39",
  null
  
)

export default component.exports